import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import AdminLayout from '../../layouts/AdminLayout';
import CampaignFormModal from './CampaignFormModal';

export default function CampaignFormPage() {
  const history = useHistory();
  const { id } = useParams();

  const handleClose = () => {
    history.push('/campaigns');
  };

  const handleSuccess = () => {
    history.push('/campaigns');
  };

  return (
    <AdminLayout title={id ? 'Edit Campaign' : 'Create Campaign'}>
      <CampaignFormModal
        open={true}
        campaignId={id || null}
        onClose={handleClose}
        onSuccess={handleSuccess}
      />
    </AdminLayout>
  );
}
